// Net-revenue accounting for the Earnings & Tax page. Revenue is MONEY ACTUALLY
// RETAINED: refunded money is never counted, partially refunded orders count
// only the net kept, unpaid orders contribute nothing. Pure + CommonJS so the
// React tax tab and the Node test suite share one implementation.

const PAID_STATUSES = ["paid", "partially_refunded", "refunded"];

// Cents actually received for a job. Prefers the authoritative
// amount_paid_cents (Migration 010); legacy paid rows without it fall back to
// the recorded order price. Non-paid orders contribute zero.
function paidCents(job) {
  if (!job) return 0;
  if (job.amountPaidCents != null && Number.isFinite(Number(job.amountPaidCents))) {
    return Math.max(0, Math.round(Number(job.amountPaidCents)));
  }
  if (PAID_STATUSES.includes(String(job.paymentStatus || ""))) {
    return Math.max(0, Math.round((Number(job.price) || 0) * 100));
  }
  return 0;
}

// Cents refunded (get-orders exposes amountRefunded in dollars).
function refundedCents(job) {
  return Math.max(0, Math.round((Number(job && job.amountRefunded) || 0) * 100));
}

// Net Revenue = Amount Paid − Amount Refunded, floored at zero so malformed or
// legacy values can never produce negative revenue.
function netRevenueDollars(job) {
  return Math.max(0, paidCents(job) - refundedCents(job)) / 100;
}

function sumNetRevenue(jobs) {
  return (jobs || []).reduce((sum, j) => sum + netRevenueDollars(j), 0);
}
function sumRefunded(jobs) {
  return (jobs || []).reduce((sum, j) => sum + refundedCents(j), 0) / 100;
}
function sumGrossPaid(jobs) {
  return (jobs || []).reduce((sum, j) => sum + paidCents(j), 0) / 100;
}

module.exports = { PAID_STATUSES, paidCents, refundedCents, netRevenueDollars, sumNetRevenue, sumRefunded, sumGrossPaid };
